import { UploadyContext as n } from "@rpldy/uploady";
import { useField as p } from "formik";
import { useContext as i } from "react";
function a(o) {
  const t = i(n), [e, r, l] = p(o);
  return {
    uploadyContext: t,
    field: e,
    meta: r,
    helpers: l
  };
}
export {
  a as default
};
